'use client';

import type { PropsWithChildren } from 'react';
import { useUxpHostInfoContext } from '../shared/contexts/UxpHostInfoContext';
import { getValueForHost } from '../shared/utils/integrationHostMap';
import { HOST_ENTITIES_PROVIDERS } from './hostEntitiesProviders';

export function HostActiveEntitiesProvider({ children }: PropsWithChildren) {
  const { name: uxpHostName } = useUxpHostInfoContext();

  const Provider = getValueForHost(HOST_ENTITIES_PROVIDERS, uxpHostName);

  if (!Provider) {
    return children;
  }

  return <Provider>{children}</Provider>;
}
